import { useLocation } from 'react-router-dom'
import { useLayoutEffect } from 'react'

export const useScrollToTop = <E extends HTMLElement = HTMLElement>({
  ref,
}: {
  ref: React.RefObject<E>
}): void => {
  const { pathname } = useLocation()

  useLayoutEffect(() => {
    const element = document.getElementById('main-scroll-container') as HTMLElement
    element.scroll(0, 0)

    const clearTimer = setTimeout(() => {
      ref.current?.focus()
    }, 100)

    return (): void => {
      clearTimeout(clearTimer)
    }
  }, [pathname, ref])
}
